import React, { ReactNode } from 'react'
import { Header, Image } from 'semantic-ui-react'
import apexLogo from './apex-logo.svg'
import styles from './styles.module.less'

export interface Props {
  title: ReactNode
}

export const AppHeader = ({ title }: Props) => (
  <div className={styles.brandedHeader}>
    <Image src={apexLogo} alt="Apex Clearing" width="254" />
    <Header as="h5" className={`${styles.appTitle} test-id-app-header-title`}>
      {title}
    </Header>
  </div>
)
